<template lang="pug">
  div.group-operations
    e-form-modal(
    ref="modalForm"
    @submitModalForm="sendForm()"
    :hideDeleteButton="false"
    savingBtnLabel="Выполение"
    saveBtnLabel="Выполнить"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs()
      slot
        e-form(:formValidator="formValidator")
          div.body
            div.col
              e-form-group(
              label="Тип перерасчета"
              inputType="select"
              name="type"
              :model="fields"
              :tabView="tabView"
              :required="true"
              :options="types"
              @change="fields.branch=''"
              )

              e-form-group(
              label="Параметр перерасчета"
              inputType="select"
              name="branch"
              :model="fields"
              :tabView="tabView"
              :required="true"
              :options="parameters"
              )

              e-form-group(
              label="Период"
              inputType="calendar-range"
              name="start"
              toName="end"
              :model="fields"
              :tabView="tabView"
              :required="true"
              valueFormat="yyyy-MM-dd"
              format="dd.MM.yyyy"
              type="date"
              placeholder="от дд.мм.гггг"
              toPlaceholder="до дд.мм.гггг"
              )

              e-form-group(
              label="Значение параметра перерасчета"
              name="value"
              :model="fields"
              :tabView="tabView"
              :required="true"
              validationRule="double"
              )

              e-form-group(
                name="operation_day"
                inputType="calendar"
                label="Операционный день"
                :model="fields"
                tabView="tab1"
                :required="true"
              )

            div.col
              e-form-group(
                name="_locationType"
                inputType="select"
                label="Объект перерасчета"
                :model="fields"
                tabView="tab1"
                :options="locationTypes"
                :required="true"
              )

              e-form-group(
                v-if="fields._locationType===INVOICE_TYPE_ADDRESS"
                name="address"
                inputType="address"
                addressProvider="tree"
                :model="fields"
                tabView="tab1"
              )

              e-form-group(
                v-else-if="fields._locationType===INVOICE_TYPE_POST"
                key="INVOICE_TYPE_POST"
                tabView="tab1"
                :model="fields"
                label="Почтовое отделение"
                placeholder="Начните вводить название либо индекс либо адрес"
                inputType="suggestion"
                name="pochtamtName"
                realName="pochtamt_index"
                :options="postOffices"
                :useInnerSearch="true"
                :minSuggestLen="0"
                :maxShowedOptions="Infinity"
                :required="true"
                :dontShowErrorInFinishComponent="true"
              )

</template>

<script>
  import {billing, groupOperations, core} from "../../api/api-endpoints"
  import recalcFormMixin from "./mixins/recalc-form"

  export default {
    mixins: [recalcFormMixin],
    methods: {
      getNormatives () {
        return billing.normativeBranchs({
          query: {
            'per-page': -1
          }
        })
      },
      getTariffs () {
        return billing.branchs({
          query: {
            'per-page': -1
          }
        })
      },
      getUpdateOrCreateUrl () {
        return groupOperations.calcIndividualsCreate()
      },
      getPostOfficesEndpoint () {
        return core.postOffices({
          query: {
            'per-page': -1
          }
        })
      }
    }
  }
</script>
